module.exports = __webpack_public_path__ + "img/yj.764a8e15.jpeg";